module.exports = __webpack_public_path__ + "static/img/sc-key-demo.98021af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/screen/sc-key-demo.png
// module id = YYaT
// module chunks = 0